<template>
  <section class="admin-page">

    <!-- Header -->
    <header class="admin-header">
      <h1>Platform Settings</h1>
      <p>Global configuration affecting creators, fans, and system behavior.</p>
    </header>

    <!-- MAIN GRID -->
    <section class="settings-grid">

      <!-- LEFT -->
      <div class="space-y">

        <!-- PLATFORM MODES -->
        <div class="card">
          <h3>Platform Mode</h3>

          <div class="toggle-row">
            <div>
              <strong>Maintenance Mode</strong>
              <p class="muted">Temporarily disable creator & fan access</p>
            </div>
            <input type="checkbox" v-model="platform.maintenance" />
          </div>

          <div class="toggle-row">
            <div>
              <strong>Creator Onboarding</strong>
              <p class="muted">Allow new creator registrations</p>
            </div>
            <input type="checkbox" v-model="platform.creatorSignup" />
          </div>

          <!-- <div class="toggle-row">
            <div>
              <strong>Fan Direct Signup</strong>
              <p class="muted">Allow fans without invite links</p>
            </div>
            <input type="checkbox" v-model="platform.fanOpenSignup" />
          </div> -->
        </div>

        <!-- APPROVAL RULES -->
        <div class="card">
          <h3>Approval Rules</h3>

          <div class="toggle-row">
            <div>
              <strong>Manual Creator Approval</strong>
              <p class="muted">Admin review required before activation</p>
            </div>
            <input type="checkbox" v-model="approvals.manualCreators" />
          </div>

          <div class="toggle-row">
            <div>
              <strong>Auto-verify Social Accounts</strong>
              <p class="muted">Skip manual review if platform trust score is high</p>
            </div>
            <input type="checkbox" v-model="approvals.autoSocial" />
          </div>
        </div>

        <!-- BROADCAST LIMITS -->
        <!-- <div class="card">
          <h3>Broadcast Controls</h3>

          <div class="field">
            <label>Daily Broadcast Limit (per creator)</label>
            <input type="number" v-model="broadcasts.dailyLimit" />
          </div>

          <div class="field">
            <label>Minimum Audience Size</label>
            <input type="number" v-model="broadcasts.minAudience" />
          </div>

          <div class="toggle-row">
            <div>
              <strong>Enable Link Tracking</strong>
              <p class="muted">Track clicks on broadcast links</p>
            </div>
            <input type="checkbox" v-model="broadcasts.trackLinks" />
          </div>
        </div> -->

      </div>

      <!-- RIGHT -->
      <div class="space-y">

       
        <!-- SAVE -->
        <div class="card highlight">
          <h3>Apply Changes</h3>
          <p class="muted">
            These settings affect the entire platform immediately.
          </p>

          <button class="primary-btn full" @click="saveSettings">
            Save Platform Settings
          </button>
        </div>

      </div>

      <!-- ================= RECOVERY REQUESTS ================= -->
<div class="card">
  <h3>Account Recovery Requests</h3>

  <!-- Tabs -->
  <div class="sub-tabs">
    <button 
      :class="['sub-tab', recoveryTab==='pending' ? 'active' : '']"
      @click="changeTab('pending')">
      Pending
    </button>

    <button 
      :class="['sub-tab', recoveryTab==='reviewed' ? 'active' : '']"
      @click="changeTab('reviewed')">
      Approved / Rejected
    </button>
  </div>

  <!-- List -->
  <div v-if="filteredRecovery.length === 0" class="muted">
    No requests found
  </div>

  <div v-for="item in filteredRecovery" :key="item.rec_id" class="recovery-item">

    <div class="rec-top">
      <strong>{{ item.rec_creator_name }}</strong>
      <span class="badge">{{ item.rec_status }}</span>
    </div>

    <p class="muted small">
      {{ item.rec_platform }} → {{ item.rec_new_platform }}
    </p>

    <p class="muted small">
      Reason: {{ item.rec_reason }}
    </p>

    <!-- ACTIONS -->
    <div v-if="item.rec_status==='pending'" class="action-row">
      <button class="primary-btn small" @click="updateRecovery(item.rec_id,'approved')">
        Approve
      </button>

      <button class="danger-btn small" @click="updateRecovery(item.rec_id,'rejected')">
        Reject
      </button>
    </div>

  </div>

  <!-- PAGINATION -->
<div class="pagination" v-if="totalPages>(page+1)">

  <button 
    class="page-btn"
    :disabled="page === 0"
    @click="prevPage">
    ← Prev
  </button>

  <span class="page-info">
    Page {{ page + 1 }}
  </span>

  <button 
    class="page-btn"
    :disabled="!hasMore"
    @click="nextPage">
    Next →
  </button>

</div>
</div>

    </section>

    

  </section>
</template>

<script>
import {
  loadPlatformSettingsApi,
  savePlatformSettingsApi,
  updateRecoveryApi,
  loadRecoveryApi
} from "../apis/adminsetapis";
import { useToast } from "vue-toastification";


export default {
  name: "AdminSettings",

  data() {
    return {
      toast:null,
      hasMore: true,
      page:0,
      total:0,
      totalPages:0,
      recoveryTab: "pending",
      recoveryRequests: [],
      platform: {
        maintenance: false,
        creatorSignup: true,
        fanOpenSignup: false
      },

      approvals: {
        manualCreators: true,
        autoSocial: false
      },

      broadcasts: {
        dailyLimit: 3,
        minAudience: 50,
        trackLinks: true
      },

      security: {
        creator2FA: true,
        fanOtp: true,
        blockDisposable: true
      },

      data: {
        cleanupDays: 90,
        creatorExport: true
      }
    };
  },
  computed: {
  filteredRecovery() {
    if (this.recoveryTab === "pending") {
      return this.recoveryRequests.filter(r => r.rec_status === "pending");
    } else {
      return this.recoveryRequests.filter(r => r.rec_status !== "pending");
    }
  }
},
  async mounted() {
    this.toast = useToast();
    this.loadSettings();
    this.loadRecoveryRequests(); // ✅ ADD THIS
  },

  methods: {
    changeTab(tab) {
      this.recoveryTab = tab;
      this.page = 0; // reset
      this.loadRecoveryRequests();
    },
    nextPage() {
      if (!this.hasMore) return;

      this.page++;
      this.loadRecoveryRequests();
    },

    prevPage() {
      if (this.page === 0) return;

      this.page--;
      this.loadRecoveryRequests();
    },
    async loadRecoveryRequests() {
      const res = await loadRecoveryApi(this.page+"");

      if (res.status) {
        this.recoveryRequests = res.data;
        this.total = res.total;
        this.hasMore = this.page < (this.total/10);
        this.totalPages = Math.ceil(this.total / 10);
      }
    },

    async updateRecovery(id, status) {
      const res = await updateRecoveryApi({
        rec_id: id,
        status: status
      });

      if (res.status) {
        this.toast.success("Updated");
        this.loadRecoveryRequests();
      }
    },
    async loadSettings() {
      const res = await loadPlatformSettingsApi();

      if (res.status && res.settings) {

        const s = res.settings;

        this.platform.maintenance   = s.adset_maintenance_mode === "1";
        this.platform.creatorSignup = s.adset_creator_signup === "1";
        this.platform.fanOpenSignup = s.adset_fan_open_signup === "1";

        this.approvals.manualCreators = s.adset_manual_creator_approval === "1";
        this.approvals.autoSocial     = s.adset_auto_social_verify === "1";

        this.broadcasts.dailyLimit = parseInt(s.adset_daily_broadcast_limit || 0);
        this.broadcasts.minAudience = parseInt(s.adset_min_audience_size || 0);

        this.security.blockDisposable = s.adset_block_disposable_email === "1";
      }
    },

    async saveSettings() {
      const ldataRaw = sessionStorage.getItem("ldata");
      const ldata = ldataRaw ? JSON.parse(ldataRaw) : null;
      const res = await savePlatformSettingsApi({

        maintenance: this.platform.maintenance ? "1" : "0",
        creatorSignup: this.platform.creatorSignup ? "1" : "0",
        fanOpenSignup: this.platform.fanOpenSignup ? "1" : "0",

        manualCreators: this.approvals.manualCreators ? "1" : "0",
        autoSocial: this.approvals.autoSocial ? "1" : "0",

        dailyLimit: this.broadcasts.dailyLimit,
        minAudience: this.broadcasts.minAudience,

        blockDisposable: this.security.blockDisposable ? "1" : "0",

        by: ldata.user_id
      });

      if (res.status) {
        this.toast.success("Platform settings updated");
      }
    }
  }
};
</script>

<style scoped>
.admin-page {
  max-width: 1440px;
  margin: auto;
  padding: 48px;
}

.admin-header h1 {
  font-size: 36px;
  font-weight: 800;
}

.admin-header p {
  color: #64748b;
  margin-top: 6px;
}

/* Grid */
.settings-grid {
  display: grid;
  grid-template-columns: 2fr 1fr;
  gap: 32px;
  margin-top: 32px;
}

.space-y > * {
  margin-bottom: 24px;
}

/* Card */
.card {
  background: white;
  border-radius: 24px;
  padding: 32px;
  border: 1px solid #e5e7eb;
}

.card h3 {
  font-size: 20px;
  font-weight: 800;
  margin-bottom: 24px;
}

.card.highlight {
  border: 2px solid #0f172a;
}

/* Fields */
.field label {
  font-size: 11px;
  text-transform: uppercase;
  color: #94a3b8;
  font-weight: 700;
}

.field input {
  width: 100%;
  margin-top: 6px;
  padding: 14px;
  border-radius: 14px;
  background: #f8fafc;
}

/* Toggles */
.toggle-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 14px 0;
  border-bottom: 1px solid #f1f5f9;
}

.toggle-row:last-child {
  border-bottom: none;
}

.muted {
  font-size: 13px;
  color: #94a3b8;
}

/* Button */
.primary-btn {
  background: #0f172a;
  color: white;
  padding: 16px 22px;
  border-radius: 14px;
  font-weight: 800;
}

.primary-btn.full {
  width: 100%;
  margin-top: 16px;
}

/* Mobile */
@media (max-width: 900px) {
  .settings-grid {
    grid-template-columns: 1fr;
  }
}

/* ===============================
   ADMIN PLATFORM SETTINGS – MOBILE
   =============================== */
@media (max-width: 640px) {

  /* Page padding */
  .admin-page {
    padding: 20px 16px 72px;
  }

  /* Header */
  .admin-header h1 {
    font-size: 26px;
    line-height: 1.2;
  }

  .admin-header p {
    font-size: 14px;
  }

  /* Grid → stacked */
  .settings-grid {
    gap: 20px;
    margin-top: 24px;
  }

  /* Cards */
  .card {
    padding: 18px;
    border-radius: 18px;
  }

  .card h3 {
    font-size: 18px;
    margin-bottom: 16px;
  }

  /* Fields */
  .field input {
    padding: 12px;
    border-radius: 12px;
    font-size: 14px;
  }

  /* Toggle rows → vertical */
  .toggle-row {
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
    padding: 12px 0;
  }

  .toggle-row strong,
  .toggle-row span {
    font-size: 14px;
  }

  .muted {
    font-size: 12px;
  }

  /* Checkbox alignment */
  .toggle-row input[type="checkbox"] {
    align-self: flex-end;
  }

  /* Save button */
  .primary-btn {
    padding: 14px 18px;
    border-radius: 12px;
    font-size: 14px;
  }

  .primary-btn.full {
    margin-top: 12px;
  }
}
.sub-tabs {
  display: flex;
  gap: 8px;
  margin-bottom: 16px;
}

.sub-tab {
  padding: 8px 14px;
  border-radius: 999px;
  font-weight: 700;
  background: #f1f5f9;
}

.sub-tab.active {
  background: #0f172a;
  color: white;
}

.recovery-item {
  padding: 14px 0;
  border-bottom: 1px solid #f1f5f9;
}

.rec-top {
  display: flex;
  justify-content: space-between;
}

.badge {
  font-size: 11px;
  padding: 4px 10px;
  border-radius: 999px;
  background: #f1f5f9;
}

.small {
  font-size: 12px;
}

.primary-btn.small,
.danger-btn.small {
  padding: 8px 12px;
  font-size: 12px;
}

.danger-btn {
  background: #ef4444;
  color: white;
  border-radius: 10px;
}

.pagination {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 16px;
}

.page-btn {
  padding: 8px 14px;
  border-radius: 10px;
  background: #0f172a;
  color: white;
  font-size: 12px;
  font-weight: 700;
}

.page-btn:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

.page-info {
  font-size: 13px;
  font-weight: 700;
  color: #475569;
}
</style>
